import AddAlbumPage from './AddAlbumPage';
export default AddAlbumPage;